import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { gsap } from 'gsap';

import useStyles from './useStyles';

const Background = ({ children }) => {
  const classes = useStyles();
  const cityRef = useRef(null);
  const containerRef = useRef(null);
  const coastRef = useRef(null);
  const forestRef = useRef(null);

  const parallax = (e, ref, movement) => {
    const mousePositionX = e.pageX;
    const containerWidth = containerRef.current.clientWidth;
    const x = ((mousePositionX - containerWidth / 2) / containerWidth) * movement;
    gsap.to(ref.current, { transform: `translateX(calc(-50% + ${x}px))`, duration: 1 });
  };

  const handleMouseMove = e => {
    parallax(e, coastRef, -300);
    parallax(e, cityRef, -200);
    parallax(e, forestRef, -70);
  };

  return (
    <div className={classes.container} onMouseMove={handleMouseMove} ref={containerRef}>
      <div className={classes.mobile} />

      <div className={classes.clouds} />
      <div className={classes.desktop}>
        <div className={classes.water}>
          <div className={classes.wave} />
          <div className={classes.wave} />
          <div className={classes.wave} />
          <div className={classes.wave} />
          <div className={classes.wave} />
        </div>
        <div className={classes.forest} ref={forestRef} />
        <div className={classes.city} ref={cityRef} />
        <div className={classes.coast} ref={coastRef} />
      </div>
      {children}
    </div>
  );
};

Background.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default Background;



// WEBPACK FOOTER //
// ./src/components/NonAuthHomePage/components/Banner/components/Background/Background.js